import { getComponentFromName } from '@folklore/utils';
import classNames from 'classnames';
import camelCase from 'lodash-es/camelCase';

import * as SecondaryImages from './svg/index';

import styles from '../../styles/animations/mes-quebec/article-image.module.css';

interface ArticleImageProps {
    className?: string | null;
    imageName?: string | null;
    imageUrl?: string | null;
}

function ArticleImage({
    className = null,
    imageName = null,
    imageUrl = null,
    ...props
}: ArticleImageProps) {
    const finalImageName = imageName !== null ? camelCase(imageName || '') : 'empty';
    const SecondaryImage = getComponentFromName(SecondaryImages, finalImageName);

    return (
        <div
            className={classNames(
                styles.container,
                {
                    [styles[finalImageName]]: finalImageName !== null,
                },
                className,
            )}
        >
            <div className={styles.images}>
                <img className={styles.mainImage} src={imageUrl} alt={imageName || ''} />
                {SecondaryImage !== null ? (
                    <SecondaryImage className={styles.secondaryImage} />
                ) : null}
            </div>
        </div>
    );
}

export default ArticleImage;
